/**
 * Spreadsheet-style formula functions for page expressions (layered
 * expressions). Thin typed re-export of the CROSS-RUNTIME shared stdlib
 * (ADR-0018): the canonical implementation lives in
 * `backend/src/hub/workflow/formulas.js` (one source of truth), injected into
 * QuickJS for workflows and imported here for the app/page runtime (registered
 * into `lib/pageExpr` + declared in the IntelliSense `.d.ts`). So a formula
 * evaluates identically in a workflow node and an app page.
 */
import { FORMULAS, FORMULA_DEFS as SHARED_DEFS } from "@shared/formulas";

/** name → implementation map (registered as callable globals in pageExpr). */
export const FORMULA_FNS: Record<string, (...args: any[]) => unknown> = FORMULAS;

/** TS declarations + docs for the page-bindings `.d.ts` (autocomplete). */
export const FORMULA_DEFS = SHARED_DEFS;
